import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=49a2db14&scoped=true&"
import script from "./project-detail.vue?vue&type=script&lang=js&"
export * from "./project-detail.vue?vue&type=script&lang=js&"
import style0 from "./project-detail.vue?vue&type=style&index=0&id=49a2db14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2db14",
  null
  
)

export default component.exports